import * as React from 'react'
import styled from 'styled-components'

const Content = styled.div`
  position: relative;
`

export const TabsContent = ({ children }: { children: React.ReactNode }) => {
  const contentRef = React.useRef<HTMLDivElement | null>(null)
  const [height, setHeight] = React.useState(0)

  React.useEffect(() => {
    const observer = new ResizeObserver(() => {
      let newHeight = 0

      const children = (contentRef.current?.children ? [...contentRef.current.children] : []) as HTMLDivElement[]
      children.forEach(child => {
        child.style.height = ''
        newHeight = Math.max(newHeight, child.getBoundingClientRect().height)
      })

      setHeight(newHeight)
      children.forEach(child => {
        child.style.height = `${newHeight}px`
      })
    })

    const children = contentRef.current?.children ? [...contentRef.current.children] : []
    children.forEach(child => {
      const subChildren = [...child.querySelectorAll('img')]
      subChildren.forEach(subChild => {
        observer.observe(subChild)
      })
      observer.observe(child)
    })

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <Content style={{ height: `${height}px` }} ref={contentRef}>
      {children}
    </Content>
  )
}
